import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fb90fa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "analyzing-outer flex column justify-center items-center responsive-full-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analyzing-lottie" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-m-b q-ma-none" }, "새미가 결과를 분석하고 있어요", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-m-b q-ma-none" }, "잠시만 기다려 주세요!", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import Lottie from 'lottie-web';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Analyzing',
  setup(__props) {

const analyzingSrc = require('assets/assessment/lottie/analyzing.json');

function playAnalyzeLottie() {
  const lottieElement = document.querySelector('.analyzing-lottie');
  if (lottieElement) {
    Lottie.loadAnimation({
      container: lottieElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: analyzingSrc,
    });
  }
}

onMounted(() => playAnalyzeLottie());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}
}

})